export default {
  state: {
    listDebtStatuses: [],
    listContragents: [],
    listCallStatuses: [],
    listDepartureStatuses: [],
    listCallTypes: [],
    listPhoneTypes: [],
    listAddressTypes: [],
    listContactfaceTypes: [],
  },
  mutations: {
    SET_LIST_DEBT_STATUSES(state, payload) {
      state.listDebtStatuses = payload.statuses;
    },
    SET_LIST_CONTRAGENTS(state, payload) {
      state.listContragents = payload.contragents;
    },
    SET_LIST_CALL_STATUSES(state, payload) {
      state.listCallStatuses = payload.statuses;
    },
    SET_LIST_CALL_TYPES(state, payload) {
      state.listCallTypes = payload.types;
    },
    SET_LIST_PHONE_TYPES(state, payload) {
      state.listPhoneTypes = payload.types;
    },
    SET_LIST_ADDRESS_TYPES(state, payload) {
      state.listAddressTypes = payload.types;
    },
    SET_LIST_DEPARTURE_STATUSES(state, payload) {
      state.listDepartureStatuses = payload.statuses;
    },
    SET_LIST_CONTACTFACE_TYPES(state, payload) {
      state.listContactfaceTypes = payload.types;
    },
  },
  actions: {
    async GET_LIST_DEBT_STATUSES({ commit }) {
      try {
        const { data } = await window.axios.get('/get/debt/statuses');
        commit('SET_LIST_DEBT_STATUSES', data);
      } catch (err) {
        throw err;
      }
    },
    async GET_LIST_CONTRAGENTS({ commit }) {
      try {
        const { data } = await window.axios.get('/get/contragents');
        commit('SET_LIST_CONTRAGENTS', data);
      } catch (err) {
        throw err;
      }
    },
    async GET_LIST_CALL_STATUSES({ commit }) {
      try {
        const { data } = await window.axios.get('/get/call/statuses');
        commit('SET_LIST_CALL_STATUSES', data);
      } catch (err) {
        throw err;
      }
    },

    async GET_LIST_CALL_TYPES({ commit }) {
      try {
        const { data } = await window.axios.get('/get/call/types');
        commit('SET_LIST_CALL_TYPES', data);
      } catch (err) {
        throw err;
      }
    },

    async GET_LIST_PHONE_TYPES({ commit }) {
      try {
        const { data } = await window.axios.get('/get/phone/types');
        commit('SET_LIST_PHONE_TYPES', data);
      } catch (err) {
        throw err;
      }
    },
    async GET_LIST_ADDRESS_TYPES({ commit }) {
      try {
        const { data } = await window.axios.get('/get/address/types');
        commit('SET_LIST_ADDRESS_TYPES', data);
      } catch (err) {
        throw err;
      }
    },
    async GET_LIST_DEPARTURE_STATUSES({ commit }) {
      try {
        const { data } = await window.axios.get('/get/departure/statuses');
        commit('SET_LIST_DEPARTURE_STATUSES', data);
      } catch (err) {
        throw err;
      }
    },
    async GET_LIST_CONTACTFACE_TYPES({ commit }) {
      try {
        const { data } = await window.axios.get('/get/contactface/types');
        commit('SET_LIST_CONTACTFACE_TYPES', data);
      } catch (err) {
        throw err;
      }
    },
  },
  getters: {
    listDebtStatuses(state) {
      return state.listDebtStatuses;
    },
    listContragents(state) {
      return state.listContragents;
    },
    listCallStatuses(state) {
      return state.listCallStatuses;
    },
    listCallTypes(state) {
      return state.listCallTypes;
    },
    listPhoneTypes(state) {
      return state.listPhoneTypes;
    },
    listAddressTypes(state) {
      return state.listAddressTypes;
    },
    listDepartureStatuses(state) {
      return state.listDepartureStatuses;
    },
    listContactfaceTypes(state) {
      return state.listContactfaceTypes;
    },
  },
};
